import { types } from '../constants';

export const openCreateBranchDialogDispatch = (open) => ({
  type: types.OPEN_CREATE_BRANCH_DIALOG,
  open
});

export const openEditBranchDialogDispatch = (open) => ({
  type: types.OPEN_EDIT_BRANCH_DIALOG,
  open
});

export const searchTermChangeForBranch = (searchTerm) => ({
  type: types.CHANGE_SEARCH_TERM_ALL_BRANCH,
  searchTerm
});

export const getBranches = () => ({
  type: types.GET_ALL_BRANCH
});

export const handleBranchInputChangeDispatch = (value, inputFieldName) => ({
  type: types.INPUT_CHANGE_CREATE_BRANCH_FORM,
  value,
  inputFieldName
});

export const submitBranchDispatch = (branch, mode) => ({
  type: types.SUBMIT_BRANCH,
  branch,
  mode
});

export const BranchEditClickDispatch = (branch) => ({
  type: types.EDIT_BRANCH,
  branch
});

export const showDeleteOrDeactiveBranchDialogStateChanged = (
  open,
  branchId,
  status
) => ({
  type: types.DEACTIVATE_OR_DELETE_BRANCH_DIALOG,
  open,
  branchId,
  status
});

export const DeactiveOrDeleteBranchDispatch = (branch) => ({
  type: types.DEACTIVATE_OR_DELETE_BRANCH,
  branch
});

export const setCurrentBranchesRecordDispatch = (recordType) => ({
  type: types.SET_CURRENT_BRANCHES_RECORD,
  recordType
});

export const fetchBranchDetailsForUserDispatch = (userId) => ({
  type: types.FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER,
  userId
});

export const fetchBranchDetailsByBranchIdDispatch = (branchId) => ({
  type: types.FETCH_BRANCH_DETAILS_BY_BRANCH_ID,
  branchId
});
